module.exports = __webpack_public_path__ + "img/2.0609cdb5.jpg";